import { searchTourPackages, getDestinationOptions } from "@/src/actions/tour/tourAction";
import SearchResult from "@/src/components/Tour/SearchResult";
import { searchResult } from "@/src/components/Tour/staticDatas/apiReplicateData";
import TourSearchForm from "@/src/components/Tour/TourSearchForm";
import { Paths } from "@/src/constants/Paths";
import { Loader } from "lucide-react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import useSEO from "../../hooks/useSEO";

export const SearchResultsPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setSEO } = useSEO();

  const initialValues = {
    destination: searchParams.get("destination") ?? "",
    month: searchParams.get("month") ?? "",
    pageSize: searchParams.get("pageSize") ?? 10,
    pageNo: searchParams.get("pageNo") ?? 1,
  };
  const { destinationOptions } = useSelector((state) => state.tours);
  const [loading, setIsLoading] = useState(true);
  const [result, setResult] = useState(null);

  useEffect(() => {
    if (destinationOptions.length === 0) {
      dispatch(getDestinationOptions());
    }
  }, [dispatch, destinationOptions.length]);

  useEffect(() => {
    const destinationId = initialValues?.destination;
    if (destinationId) {
      getTourSearchResult();

      const destinationName = destinationOptions.find(
        (d) => String(d.Value) === String(destinationId)
      )?.Text || destinationId;

      setSEO(`Tour Search: ${destinationName} | Yatra Tickets`, `Explore tour packages for ${destinationName}.`);
    }
    else {
      setIsLoading(false);
      setSEO(`Tour Packages | Yatra Tickets`, `Explore our wide range of tour packages.`);
    }
  }, [searchParams, setSEO, destinationOptions]);

  const getTourSearchResult = () => {

    dispatch(searchTourPackages(initialValues.destination, initialValues.pageSize, initialValues.pageNo, initialValues.month, (resp) => {
      if (resp) {
        const result = resp.Result; // { Items, RowTotal, PageNumber, PageSize }
        setResult(result);
      }
      setIsLoading(false);
    }))
  }

  return (
    <>
      <TourSearchForm onSearch={(payload) => {
        // update URL & reload results
        navigate(
          Paths.TOUR_SEARCH +
          "?" +
          new URLSearchParams(payload).toString()
        );
      }}
        initialValues={initialValues}
      />
      {loading ? <Loader /> :
        <SearchResult
          result={result}
          initialQuery={initialValues.destination}
          month={initialValues.month}
          pageSize={initialValues.pageSize}
        />
      }
    </>
  );
}